<script>
export default {
	name: 'ButtonTableResetAllSelected',
	
	components: {
	
	},
	
	data() {
		return {
			datas:[],
			isSelected:false
		}
	},
	
	props: {'totalCount': Number, 'selectedItemStore': Object, 'allSelectedItems': Array, 'dataList': Array },
	emits: ['changeSelected'],

	mounted:function(){
		this.datas=this.dataList;
	},
	
	methods: {
		handleClick(){
			for(let i = this.allSelectedItems.length; i>=0 ;i--){
				var indexToRemove = this.allSelectedItems.indexOf(this.allSelectedItems[i]);
				if(indexToRemove>=0){
					var index = this.datas.findIndex(item => item.id==this.allSelectedItems[i]); 
					
					if(index>=0){
						console.log('index')
						this.datas[index].selectedId=false;
					}
					this.selectedItemStore.deleteSelectedItems(indexToRemove);
				}
			}
			this.$emit('changeSelected',this.datas)
		}
	},	
	
	watch: {
		dataList() {
			this.datas=this.dataList;
		},
	},

	computed:{
		
	},
	
}
</script>

<template>
	<div>
		<span>Počet: {{totalCount}} <button v-if="allSelectedItems.length>0" type="button" @click="handleClick()" class="btn btn-sm btn-info">Vybr.:{{ allSelectedItems.length }} <i class="fas fa-times"></i></button></span>
	</div>
</template>


